/**
 * cities.js — static city-to-coordinates lookup
 * Format: [name_lowercase, lat, lon, displayName]
 */

export const CITIES = [
  // US cities
  ['new york',       40.7128,  -74.0060,  'New York'],
  ['los angeles',    34.0522, -118.2437,  'Los Angeles'],
  ['chicago',        41.8781,  -87.6298,  'Chicago'],
  ['houston',        29.7604,  -95.3698,  'Houston'],
  ['phoenix',        33.4484, -112.0740,  'Phoenix'],
  ['philadelphia',   39.9526,  -75.1652,  'Philadelphia'],
  ['san antonio',    29.4241,  -98.4936,  'San Antonio'],
  ['san diego',      32.7157, -117.1611,  'San Diego'],
  ['dallas',         32.7767,  -96.7970,  'Dallas'],
  ['san francisco',  37.7749, -122.4194,  'San Francisco'],
  ['austin',         30.2672,  -97.7431,  'Austin'],
  ['seattle',        47.6062, -122.3321,  'Seattle'],
  ['denver',         39.7392, -104.9903,  'Denver'],
  ['boston',         42.3601,  -71.0589,  'Boston'],
  ['atlanta',        33.7490,  -84.3880,  'Atlanta'],
  ['miami',          25.7617,  -80.1918,  'Miami'],
  ['portland',       45.5051, -122.6750,  'Portland'],
  ['las vegas',      36.1699, -115.1398,  'Las Vegas'],
  ['detroit',        42.3314,  -83.0458,  'Detroit'],
  ['nashville',      36.1627,  -86.7816,  'Nashville'],
  ['minneapolis',    44.9778,  -93.2650,  'Minneapolis'],
  ['new orleans',    29.9511,  -90.0715,  'New Orleans'],
  ['charlotte',      35.2271,  -80.8431,  'Charlotte'],
  ['pittsburgh',     40.4406,  -79.9959,  'Pittsburgh'],
  ['columbus',       39.9612,  -82.9988,  'Columbus'],
  ['indianapolis',   39.7684,  -86.1581,  'Indianapolis'],
  ['milwaukee',      43.0389,  -87.9065,  'Milwaukee'],
  ['baltimore',      39.2904,  -76.6122,  'Baltimore'],
  ['salt lake city', 40.7608, -111.8910,  'Salt Lake City'],
  ['honolulu',       21.3069, -157.8583,  'Honolulu'],
  ['anchorage',      61.2181, -149.9003,  'Anchorage'],
  ['new haven',      41.3083,  -72.9279,  'New Haven, CT'],
  ['hartford',       41.7658,  -72.6734,  'Hartford, CT'],
  ['providence',     41.8240,  -71.4128,  'Providence, RI'],
  ['richmond',       37.5407,  -77.4360,  'Richmond, VA'],
  ['raleigh',        35.7796,  -78.6382,  'Raleigh, NC'],
  ['memphis',        35.1495,  -90.0490,  'Memphis, TN'],
  ['louisville',     38.2527,  -85.7585,  'Louisville, KY'],
  ['oklahoma city',  35.4676,  -97.5164,  'Oklahoma City, OK'],
  ['tucson',         32.2226,  -110.9747, 'Tucson, AZ'],
  ['albuquerque',    35.0844,  -106.6504, 'Albuquerque, NM'],
  ['sacramento',     38.5816,  -121.4944, 'Sacramento, CA'],
  ['san jose',       37.3382,  -121.8863, 'San Jose, CA'],
  ['jacksonville',   30.3322,  -81.6557,  'Jacksonville, FL'],
  ['orlando',        28.5383,  -81.3792,  'Orlando, FL'],
  ['tampa',          27.9506,  -82.4572,  'Tampa, FL'],
  ['st louis',       38.6270,  -90.1994,  'St. Louis, MO'],
  ['kansas city',    39.0997,  -94.5786,  'Kansas City, MO'],
  ['washington',     38.9072,  -77.0369,  'Washington, DC'],
  ['dc',             38.9072,  -77.0369,  'Washington, DC'],
  ['bridgeport',     41.1865,  -73.1952,  'Bridgeport, CT'],
  ['stamford',       41.0534,  -73.5387,  'Stamford, CT'],
  ['waterbury',      41.5582,  -73.0515,  'Waterbury, CT'],
  ['ulm',            48.4011,    9.9876,  'Ulm, Germany'],

  // World cities
  ['london',         51.5074,   -0.1278,  'London'],
  ['paris',          48.8566,    2.3522,  'Paris'],
  ['tokyo',          35.6762,  139.6503,  'Tokyo'],
  ['berlin',         52.5200,   13.4050,  'Berlin'],
  ['sydney',        -33.8688,  151.2093,  'Sydney'],
  ['toronto',        43.6532,  -79.3832,  'Toronto'],
  ['mumbai',         19.0760,   72.8777,  'Mumbai'],
  ['mexico city',    19.4326,  -99.1332,  'Mexico City'],
  ['são paulo',     -23.5505,  -46.6333,  'São Paulo'],
  ['sao paulo',     -23.5505,  -46.6333,  'São Paulo'],
  ['cairo',          30.0444,   31.2357,  'Cairo'],
  ['lagos',           6.5244,    3.3792,  'Lagos'],
  ['beijing',        39.9042,  116.4074,  'Beijing'],
  ['shanghai',       31.2304,  121.4737,  'Shanghai'],
  ['seoul',          37.5665,  126.9780,  'Seoul'],
  ['bangkok',        13.7563,  100.5018,  'Bangkok'],
  ['istanbul',       41.0082,   28.9784,  'Istanbul'],
  ['moscow',         55.7558,   37.6173,  'Moscow'],
  ['buenos aires',  -34.6037,  -58.3816,  'Buenos Aires'],
  ['johannesburg',  -26.2041,   28.0473,  'Johannesburg'],
  ['rome',           41.9028,   12.4964,  'Rome'],
  ['madrid',         40.4168,   -3.7038,  'Madrid'],
  ['amsterdam',      52.3676,    4.9041,  'Amsterdam'],
  ['dublin',         53.3498,   -6.2603,  'Dublin'],
  ['singapore',       1.3521,  103.8198,  'Singapore'],
  ['hong kong',      22.3193,  114.1694,  'Hong Kong'],
  ['tel aviv',       32.0853,   34.7818,  'Tel Aviv'],
  ['dubai',          25.2048,   55.2708,  'Dubai'],
  ['nairobi',        -1.2921,   36.8219,  'Nairobi'],
  ['lima',          -12.0464,  -77.0428,  'Lima'],
  ['bogotá',          4.7110,  -74.0721,  'Bogotá'],
  ['bogota',          4.7110,  -74.0721,  'Bogotá'],
];

/**
 * findCity(input) — fuzzy city lookup
 * Tries: exact match → starts-with → contains
 * Returns { lat, lon, name } or null
 *
 * @param {string} input
 * @returns {{ lat: number, lon: number, name: string } | null}
 */
export function findCity(input) {
  if (!input || typeof input !== 'string') return null;

  let q = input.trim().toLowerCase();
  if (!q) return null;

  // Strip common suffixes: state names, country names, abbreviations
  q = q.replace(/,?\s*(ct|ny|ca|tx|fl|il|ma|pa|oh|nj|va|wa|or|co|az|nv|ga|nc|tn|mo|md|ri|ky|ok|nm|hi|ak|dc|mn|la|wi|in|ut)\s*$/i, '').trim();
  q = q.replace(/,?\s*(connecticut|california|texas|florida|new york|massachusetts|pennsylvania|ohio|virginia|maryland|usa|us|united states|england|uk|canada|australia|germany|france|japan|india|china|mexico|brazil)\s*$/i, '').trim();

  // 1. Exact match
  let match = CITIES.find(([key]) => key === q);

  // 2. Starts-with
  if (!match) {
    match = CITIES.find(([key]) => key.startsWith(q));
  }

  // 3. Contains
  if (!match) {
    match = CITIES.find(([key]) => key.includes(q));
  }

  // 4. Reverse contains (query contains city name)
  if (!match) {
    match = CITIES.find(([key]) => q.includes(key));
  }

  if (!match) return null;

  const [, lat, lon, name] = match;
  return { lat, lon, name };
}
